<div class="eventq-event-meta-bar">
  <div class="eventq-event-meta-bar__primary">
    <h1 class="eventq-event-meta-bar__title">{{ title() }}</h1>
    <div class="eventq-event-meta-bar__details">
      <span class="eventq-event-meta-bar__detail">Event ID: {{ eventId() }}</span>
      <span class="eventq-event-meta-bar__detail eventq-event-meta-bar__address">{{ address() }}</span>
      <span class="eventq-event-meta-bar__detail">Current Time: {{ currentTime() }}</span>
    </div>
  </div>
  <div class="eventq-event-meta-bar__actions">
    <ng-content select="[eventqEventMetaActions]" />
  </div>
</div>
